import { RENTABIKE } from "../rentabikeConstants";

export const returnAvailableTimes = (pickup_date, pickup_time, return_date) => {
  let returnTimes = RENTABIKE.AVAILABLE_TIME.map((t) => ({
    value: t,
    label: t,
  }));

  if (
    pickup_time &&
    pickup_date &&
    pickup_date?.toISOString().split("T")[0] ===
      return_date?.toISOString().split("T")[0]
  )
    returnTimes = returnTimes.filter((t) => t.value > pickup_time);

  return returnTimes;
};
